import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RegistroventasComponent } from './registroventas/registroventas.component';
import { ConsultaComponent } from './consulta/consulta.component';
import { MonitoRegistroventasComponent } from './monito-registroventas/monito-registroventas.component';
import { RegistoVentasRoutingModule } from './registro-routing.module';
import { RegistroventasitemComponent } from './registroventasitem/registroventasitem.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ConsultaregistroComponent } from './consultaregistro/consultaregistro.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { MaestroUsuarioComponent } from './maestro-usuario/maestro-usuario.component';
import { MaestroUsuarioAddComponent } from './maestro-usuario-add/maestro-usuario-add.component';
import { MaestroUsuarioEditComponent } from './maestro-usuario-edit/maestro-usuario-edit.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReporteVentasComponent } from './reporte-ventas/reporte-ventas.component';
import { ExcelService } from './Services/excel.service';
import { RegistroventacertificadaComponent } from './registroventacertificada/registroventacertificada.component';
import { ConsultarventacertificadaComponent } from './consultarventacertificada/consultarventacertificada.component';
import { MonitorVentasCertificadasComponent } from './monitor-ventas-certificadas/monitor-ventas-certificadas.component';
import { ReporteVentasCertificadasComponent } from './reporte-ventas-certificadas/reporte-ventas-certificadas.component';
import { ReporteclienteVentasCertificadasComponent } from './reportecliente-ventas-certificadas/reportecliente-ventas-certificadas.component';
import { ReporteVentasCcComponent } from './reporte-ventas-cc/reporte-ventas-cc.component';
import { ReporteVentasGeneralmmComponent } from './reporte-ventas-generalmm/reporte-ventas-generalmm.component';
import { ReporteVentasGraficommComponent } from './reporte-ventas-graficomm/reporte-ventas-graficomm.component';
import { ReporteVentasMarcasComponent } from './reporte-ventas-marcas/reporte-ventas-marcas.component';
import { CurrencyPipe } from '@angular/common';
import { CurrencyInputDirective } from '../utilities/currency-input.directive';
import { ReporteVentasMarcaGralComponent } from './reporte-ventas-marcaGral/reporte-ventas-marcaGral.component';
import { NgbdDatepickerRangeModule } from '../utilities/datepickerrange/datepicker-range.module';
import { VentaMarcaChartModule } from './reporte-ventas-marcas/venta-marca-chart/venta-marca-chart.module';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbdDatepickerRange } from '../utilities/datepickerrange/datepicker-range';
import { MatRadioModule } from '@angular/material/radio';
import { MatIconModule } from '@angular/material/icon';
import { CondicionesMovimientosComponent } from './condiciones-movimientos/condiciones-movimientos.component';
import { CondicionesMovimientoFormComponent } from './condiciones-movimiento-form/condiciones-movimiento-form.component';
import {  MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import {MatChipsModule} from '@angular/material/chips';
import { MaestroPlanesComponent } from './maestro-planes/maestro-planes.component';
import { MatPaginatorModule } from '@angular/material/paginator';




@NgModule({
  declarations: [
    RegistroventasComponent,
    ConsultaComponent,
    MonitoRegistroventasComponent,
    RegistroventasitemComponent,
    ConsultaregistroComponent,
    MaestroUsuarioComponent,
    MaestroUsuarioAddComponent,
    MaestroUsuarioEditComponent,
    ReporteVentasComponent,
    RegistroventacertificadaComponent,
    ConsultarventacertificadaComponent,
    MonitorVentasCertificadasComponent,
    ReporteVentasCertificadasComponent,
    ReporteclienteVentasCertificadasComponent,
    ReporteVentasCcComponent,
    ReporteVentasGeneralmmComponent,
    ReporteVentasGraficommComponent,
    ReporteVentasMarcasComponent,
    CurrencyInputDirective,
    ReporteVentasMarcaGralComponent,
    NgbdDatepickerRange,
    
     CondicionesMovimientosComponent,
     CondicionesMovimientoFormComponent,
     MaestroPlanesComponent
  ],
  exports: [
    MatSelectModule,
    MatOptionModule
  ],
  imports: [
    CommonModule,
    RegistoVentasRoutingModule,
    FormsModule,
    MatRadioModule,
    ReactiveFormsModule,
    Ng2SearchPipeModule,
    NgxSpinnerModule,
    NgSelectModule,
    MatSortModule,
    MatTableModule,
    MatIconModule,
    MatChipsModule,
    MatPaginatorModule,
    VentaMarcaChartModule,
    NgbModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  // exports:[
  //   NgbdDatepickerRangeModule
  // ],
  providers: [ExcelService,
    CurrencyPipe,
    DatePipe]
})
export class RegistroModule { }
